import React from "react";
import styled from "styled-components";

import { BhHomepage1 } from "./Page1/BhHomepage1";
import { BhHomepage2 } from "./Page2/BhHomePage2";
import { BhHomepage3 } from "./Page3/BhHomePage3";
import { BhHomepage4 } from "./Page4/BhHomePage4";
import { BhHomepage5 } from "./Page5/BhHomePage5";
import { BhHomepage6 } from "./Page6/BhHomePage6";
import { BhHomepage7 } from "./Page7/BhHomePage7";
import { BhHomepage8 } from "./Page8/BhHomePage8";
import { BhHomepage9 } from "./Page9/BhHomePage9";
import { BhHomepage10 } from "./Page10/BhHomePage10";
import { BhHomepage11 } from "./Page11/BhHomePage11";
import { BhHomepage12 } from "./Page12/BhHomePageFooter";



const StyledDivWrapperScreen = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
    overflow: hidden;
    height: auto;
  // width: 1524px;
  // justify-content: center;



`;

export const BhHomepageMain = () => {


  return (
    <StyledDivWrapperScreen className="div-wrapper-screen">
      <BhHomepage1 />
      <BhHomepage2 />
      <BhHomepage3 />
      <BhHomepage4 />
      <BhHomepage5 />
      <BhHomepage6 />
      <BhHomepage7 />
      <BhHomepage8 />
      <BhHomepage9 />
      <BhHomepage10 />
      <BhHomepage11 />
      <BhHomepage12 />
    </StyledDivWrapperScreen>
  );
};